import client from './rest/AdminClient';
import { showToast } from 'stores/ToastStore';
import i18next from 'i18next';
export const validateChassis = async (chassis_id) => {
    const updates = { chassis_id };
    return await _validateChassis(updates).then((response) => {
        showToast('Validate Chassis', i18next.t('CHASSIS_VALIDATION_SUCCESFUL'));
        return response.entity;
    }, (error) => {
        showToast('Error Validating Chassis', error.message, 'error');
        throw error;
    });
};
const _validateChassis = (payload) => {
    return client({
        method: 'POST',
        path: `/api/v2/equipment/chassis/validate`,
        entity: JSON.stringify(payload),
    });
};
